import { render } from "./Permessi.vue?vue&type=template&id=27f0bd0b&scoped=true"
import script from "./Permessi.vue?vue&type=script&lang=js"
export * from "./Permessi.vue?vue&type=script&lang=js"

import "./Permessi.vue?vue&type=style&index=0&id=27f0bd0b&lang=css"
import "./Permessi.vue?vue&type=style&index=1&id=27f0bd0b&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f0bd0b"]])

export default __exports__